<p-treeSelect
  #pTreeSelect
  class="finx-workflow-treeselect"
  [class]="class"
  [disabled]="isDisabled"
  (ngModelChange)="onChange($event)"
  [(ngModel)]="selectedValue"
  [options]="options"
  [metaKeySelection]="false"
  [selectionMode]="selectionMode"
  [display]="'comma'"
  [propagateSelectionUp]="true"
  [propagateSelectionDown]="true"
  [placeholder]="placeholder"
  [appendTo]="appendto"
  [panelStyleClass]="'finx-workflow-treeselect-panel'"
  [scrollHeight]="scrollHeight"
  [overlayOptions]="getOverlayOptions()"
></p-treeSelect>
